import moment from "moment";
import { createSelector } from "reselect";
import Angie from "~/utils/angie.jsx";
import { formatDateSmart } from "~/utils/date.jsx";
import { getPersonalizedConfigOption } from "./selector.configOptions.jsx";

export const getFormattedDateTime = (state, timestamp) => {
  const dateFormat = Angie.functions.phpToMomentDateFormat(getPersonalizedConfigOption(state, `format_date`));
  const timeFormat = Angie.functions.phpToMomentTimeFormat(getPersonalizedConfigOption(state, `format_time`));

  return moment.unix(timestamp).utc().format(`${dateFormat}, ${timeFormat}`);
};

export const makeDateFormattedSelector = () => {
  return createSelector(
    (state, value) => value,
    (state, value, long) => long,
    (state) => getPersonalizedConfigOption(state, `format_date`),
    (value, long, format) => formatDateSmart(value, Angie.functions.phpToMomentDateFormat(format), long)
  );
};
